export const PROFESSIONAL_HEADER_HEIGHT_PX = 68;

export const professionalHeaderHeightClass = 'h-[68px]';

export const professionalHeaderControlHeightClass = 'h-8 shrink-0 md:h-9';

export const professionalHeaderControlTextClass =
	'text-sm font-bold leading-none';

export const professionalHeaderControlPaddingClass = 'px-3 md:px-4';

export const professionalHeaderIconOnlyButtonClass =
	'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-zinc-200 bg-white transition-colors hover:bg-zinc-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-300/70 md:h-9 md:w-9';

export const professionalHeaderProfileButtonClass =
	'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white transition-colors hover:bg-zinc-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-300/70 md:h-9 md:w-9';

export const professionalHeaderActionIconClass = 'size-4 shrink-0';

/** Usar a string literal em JSX/layout para o Tailwind JIT gerar o CSS. */
export const PROFESSIONAL_MAIN_HEIGHT_CLASS = 'h-[calc(100vh-68px)]' as const;
